module.exports = __webpack_public_path__ + "static/media/bear2.8fd59b9e.PNG";